









































import { useGlobals }                                     from '@/hooks/use-globals';
import { computed, defineComponent, ref }                 from '@vue/composition-api';
import CSelect                                            from '@/components/form/select/select.component.vue';
import cBreadcrumb                                        from '@/components/breadcrumb/breadcrumb.component.vue';
import CFooterPanel                                       from '@/components/footer-panel/footer-panel.component.vue';
import COption                                            from '@/components/form/option/option.component.vue';
import CFilterTitle                                       from '@/components/filter-panel/components/filter-title/filter-title.component.vue';
import { TranslateResult }                                from 'vue-i18n';
import { CalendarConfigurationConfig, CompsetPriceTypes } from '@/views/calendar-configuration/calendar-configuration.types';
import { deltaOptions }                                   from '@/views/calendar-configuration/calendar-configuration.variables';

export default defineComponent({
  name: 'vCalendarConfiguration',
  components: {
    CFilterTitle,
    COption,
    CSelect,
    cBreadcrumb,
    CFooterPanel,
  },
  setup() {
    const { i18n, store } = useGlobals();
    const calendarConfiguration = computed((): CalendarConfigurationConfig => store.state.views.vCalendarConfiguration.calendarConfiguration);
    const isLoading = computed((): boolean => store.state.views.vCalendarConfiguration.configurationLoading);
    const getBreadcrumbTranslation = computed((): TranslateResult => i18n.t('vCalendarConfiguration.meta.breadcrumb'));
    const getTranslation = (value: string): string => ref(i18n.t(`vCalendarConfiguration.${value}`))
      .value
      .toString();

    const saveConfiguration = async () => {
      await store.dispatch('views/vCalendarConfiguration/putCalendarConfiguration', calendarConfiguration.value);
      await store.dispatch('views/vCalendarConfiguration/getCalendarValues');
    };

    const setConfiguration = (event: Partial<CalendarConfigurationConfig>) => {
      store.commit('views/vCalendarConfiguration/setCalendarConfiguration', event);
    };

    store.dispatch('views/vCalendarConfiguration/getCalendarConfiguration');


    return {
      deltaOptions,
      setConfiguration,
      saveConfiguration,
      getTranslation,
      isLoading,
      calendarConfiguration,
      getBreadcrumbTranslation,
      CompsetPriceTypes,
    };
  },
});

